module.exports = __webpack_public_path__ + "img/hospital-clinica.b7e4f22c.jpg";